import classNames from 'classnames';
import React, { useCallback } from "react";
import './Switch.scss';
import PropTypes from 'prop-types';

const Switch = ({ disabled,
  onChange,
  checked,
  tabIndex,
  ...props
}) => {
  const handleChange = useCallback((e) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  }, [onChange]);

  return (
    <label className={classNames("switch", { disabled })}>
      <input
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={handleChange}
        tabIndex={tabIndex}
        {...props}
      />
      <span className="slider" />
    </label>
  );
};

Switch.propTypes = {
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
};

Switch.defaultProps = {
  disabled: false,
  checked: false,
  onChange: null,
  tabIndex: null
};

export default React.memo(Switch);